import request from '../utils/request';
//产品中心

//产品列表
export function productList(data) {
  return request({
    url: '/frontExhibitor/productCenter/list',
    method: 'post',
    data: data,
  });
}
//产品新增--
export function addProduct(data) {
  return request({
    url: '/frontExhibitor/productCenter/save',
    method: 'post',
    data: data,
  });
}

// 获取产品系列列表
export function getSeriesLists() {
  return request({
    url: '/frontExhibitor/productsSeries/list',
    method: 'post',
  });
}
// 更新列表排序
export function updateSort(data) {
  return request({
    url: '/frontExhibitor/productCenter/editSort',
    method: 'get',
    params: data,
  });
}
// 获取单个产品信息
export function getProduct(data) {
  return request({
    url: '/frontExhibitor/productCenter/view',
    method: 'get',
    params: data,
  });
}
// 编辑产品
export function editProduct(data) {
  return request({
    url: '/frontExhibitor/productCenter/edit',
    method: 'post',
    data: data,
  });
}
// 删除产品
export function deleteProduct(data) {
  return request({
    url: '/frontExhibitor/productCenter/delete',
    method: 'get',
    params: data,
  });
}
 
// 获取产品系列保存
export function saveSeries(data){
  return request({
    url: '/frontExhibitor/productsSeries/save',
    method: 'post',
    data: data
  });
}

// 其他展品信息
export function getOtherEx(data) {
  return request({
    url: '/onlineExhibition/otherExhibits',
    method: 'get',
    params: data,
  });
}
//展品收藏
export function collecExhibit(data) {
  return request({
    url: '/onlineExhibition/addCollect',
    method: 'get',
    params: data,
  });
}